import { ComponentProps } from "../registry";
import { useBound, writePath } from "../helpers";
import { BoundNumber, BoundValue } from "../../types";

export function Slider({ fields, scope }: ComponentProps) {
  const label = useBound<string>(fields.label as BoundValue, scope);
  const value = useBound<number>(fields.value as BoundValue, scope) ?? 0;
  const min = useBound<number>(fields.minValue as BoundValue, scope) ?? 0;
  const max = useBound<number>(fields.maxValue as BoundValue, scope) ?? 100;
  const path = (fields.value as BoundNumber | undefined)?.path;

  return (
    <label className="a2-slider">
      {label && <span className="a2-field-label">{label}: <strong>{value}</strong></span>}
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={(e) => path && writePath(path, Number(e.target.value))}
      />
    </label>
  );
}
